import { useState, useEffect } from 'react';
import { basePort, headers } from "../module_auth/AuthService"
import { useNavigate } from "react-router-dom";
import { AlertMessage } from "../component/common/Alert"
import { ToastMessage } from "../component/common/Toast"

export function MbrPvRegValidation() {
    const queryParameters = new URLSearchParams(window.location.search)
    // const param_id = window.atob(queryParameters.get("id") == null ? "" : queryParameters.get("id"));
    // const param_fullname = window.atob(queryParameters.get("fullname") == null ? "" : queryParameters.get("fullname"));
    const param_id = queryParameters.get("id") == null ? "" : queryParameters.get("id");
    const MBR_ROLE = "TEMP_PV"

    const [email, setEmail] = useState("");
    const [validationCode, setValidationCode] = useState("");

    const [disableValidationBtn, setDisableValidationBtn] = useState(false);
    const [disableSubmitBtn, setDisableSubmitBtn] = useState(true);
    const [showMessage, setShowMessage] = useState(false);
    const [message, setMessage] = useState("");

    //toast show
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState("");

    useEffect(() => {
        setEmail(param_id)
    }, []);

    function handleEmail(event) {
        setEmail(event.target.value);
    }

    let navigate = useNavigate(); 
    function moveTo() {
        let url = "/mbr_pv_mypage";
        navigate(url);
    }

    function clickSubmit(event) {
        event.preventDefault();
        fetch(basePort + '/validateMbr', 
            {method:'post', headers,
                      body:JSON.stringify({
                        email:email,
                        validationCode:validationCode,
                        mbrRole: MBR_ROLE
                    })})
                      .then(response => response.json())
                      .then(response => {
                        setToastMessage(response.validationMessage)
                        setShowToast(true)
                        setShowMessage(false)
                        if(response.validRequest){
                            setTimeout(function() {
                                backToLogin()
                            }.bind(this), 2000)
                        } else {
                            console.log("validation failed")
                        }
                        
            }).catch(error => console.log(error))
    }

    function backToLogin() {
        let url = "/login";
        navigate(url);
    }

    function clickSendValidationCode(event) {
        event.preventDefault();
        const jwtRequest = {
            email:email,
            mbrRole: MBR_ROLE
        }
        fetch(basePort + '/sendValidationCode', 
            {method:'post', headers, body:JSON.stringify(jwtRequest)})
                .then(response => response.json())
                .then(response   => {
                    setMessage(response.validationMessage)
                    setShowMessage(true)
                    if(response.validRequest){
                        setDisableValidationBtn(true)
                        setDisableSubmitBtn(false)
                    }
            }).catch(error => console.log(error))
    }

    function handleValidationCode(event) {
        setValidationCode(event.target.value)
    }

    function closeToastBtn(){
        setToastMessage("")
        setShowToast(false)
    }

    return (
        <div>
            <main class="page lanidng-page">
                <section>
                    <div class="container" style={{paddingTop:'100px', marginTop: '10px', marginBottom: '10px'}}>
                    <div class="row mb-5">
                        <div class="col-md-8 col-xl-6 text-center mx-auto">
                            <h3 style={{fontFamily: 'Nanum Gothic'}}>개인회원 이메일 인증</h3>
                            <p></p>
                        </div>
                    </div>
                    <div class="row d-flex justify-content-center">
                        <div class="col-md-6 col-xl-4" style={{width: '600px'}}>
                            <div class="card mb-5">
                                <div class="card-body d-flex flex-column align-items-center">
                                    <form class="text-center" method="post">
                                        <div class="mb-3"><input class="form-control" type="email" name="email" placeholder="이메일" onChange={handleEmail} value={email}/></div>
                                        <div class="mb-3"><input class="form-control" type="text" placeholder="인증번호 숫자 6자리" onChange={handleValidationCode}/></div>
                                        <div class="mb-3"><button class="btn btn-secondary d-block w-100" type="submit" onClick={clickSendValidationCode} disabled={disableValidationBtn}>인증번호 보내기</button></div>
                                        <div class="mb-3"><button class="btn btn-primary d-block w-100" type="submit" onClick={clickSubmit} disabled={disableSubmitBtn}>인증하기</button></div>
                                    </form>
                                </div>
                            </div>
                        <AlertMessage show={showMessage} msg={message} />
                        <ToastMessage show={showToast} msg={toastMessage} closeBtn={closeToastBtn}/>
                        </div>
                    </div>
                    </div>
                </section>
            </main>
        </div>
    );
}